import React from 'react';

import { Checkbox } from '@src/components/ui';

import FieldShell from './FieldShell';


/**
 * Base checkbox field — checkbox with inline label, helper/error line below.
 * Receives RHF field props (value/onChange/onBlur/name/ref) plus `error`/`helperText`
 * from the generic form wrapper. RHF stores the boolean, not the event.
 */
const CheckboxField = React.forwardRef((props, ref) => {
  const {
    label,
    children,
    value = false,
    onChange,
    error = false,
    helperText = ' ',
    className,
    ...restProps
  } = props;

  return (
    <FieldShell className={className} helperText={helperText} error={error}>
      <Checkbox
        ref={ref}
        invalid={error}
        checked={Boolean(value)}
        onChange={(event) => onChange?.(event.target.checked)}
        {...restProps}
      >
        {children ?? label}
      </Checkbox>
    </FieldShell>
  );
});

CheckboxField.displayName = 'CheckboxField';
export default CheckboxField;
